const guest = {
    modalBtn: document.querySelector(".login-content .guest_popup a"),
    Modal: document.querySelector(".login-content .guest_modal"),
    close: document.querySelector(".login-content .guest_modal .close_btn"),
    submitBtn: document.querySelector(
        ".login-content .guest_modal .content button"
    ),
    formInput: document.querySelector(
        ".login-content .guest_modal .content input"
    )
};

guest.modalBtn.addEventListener("click", e => {
    e.preventDefault();
    guest.Modal.classList.add("active");
});

guest.close.addEventListener("click", () => {
    guest.Modal.classList.remove("active");
});

guest.submitBtn.addEventListener("click", e => {
    e.preventDefault();
    console.log(guest.formInput.value);
    // var formData = new FormData(); // Currently empty
    // formData.append("order_number");
    var request = new XMLHttpRequest();
    request.open("GET", "/guest/result/" + guest.formInput.value, true);
    request.onload = function() {
        if (this.status >= 200 && this.status < 400) {
            // Success!
            var res = this.response;
            // location.href = "/";
            var data = JSON.parse(res);
            console.log(data);
            if (data.state === "ok") {
                location.href = "/result/" + guest.formInput.value;
            } else {
                alert(data.msg);
            }
        } else {
            // We reached our target server, but it returned an error
        }
    };
    request.onerror = function() {
        // There was a connection error of some sort
    };
    request.send();
});
